<motif-modal
  [headerTitle]="'Surveys Export'"
  size="md"
  variant="default"
  [open]="open"
  (modalClose)="onModalClose()"
>
  <div slot="body">
    <p>Please select a date range and agent to download the data.</p>
    <div style="padding: 14px">
      <div>
        <label motifLabel>Date</label>
        <motif-date-picker
          name="dateSingle"
          placeholder="Select date"
          [range]="true"
          (dateSelect)="onDateSelect($event)"
        ></motif-date-picker>
      </div>
      <div>
        <label motifLabel class="select-label">Select</label>
        <motif-select
          aria-label="Please select an option"
          placeholder="Select agent"
          [formControl]="selectAgentFormControl"
        >
          <motif-select-option value="tbe">Agent 1</motif-select-option>
          <motif-select-option value="coa">Agent 2</motif-select-option>
          <motif-select-option value="ad">Agent 5</motif-select-option>
        </motif-select>
      </div>
    </div>
  </div>

  <div slot="footer">
    <button motifButton (click)="onSurveyExport()">Download</button>
  </div>
</motif-modal>
